import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from '@modulor/react';
import { useCallback } from 'react';
import Local from '../Local/Local';
import { getBonusDetailRoute } from '../../utils/routes';
import { isLoggedInSelector } from '../../redux/reducers/app/params';
import { useWageringBonus } from '../../hooks/API/useQueryBonuses';
import { usePromoBonusRedirect } from '../../hooks/usePromoBonusSystemRedirects';
import { useIsUnifiedPromoBonusSystemEnabled } from '../../hooks/useIsUnifiedPromoBonusSystemEnabled';
import { NAMESPACES } from '../../constants/namespaces';
import styles from './LinkToWageringBonus.module.css';

export const LinkToWageringBonus = () => {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const { data: bonus, isLoading } = useWageringBonus({ enabled: isLoggedIn });
  const history = useHistory();

  const isPromoBonusSystemEnabled = useIsUnifiedPromoBonusSystemEnabled();

  const promoBonusRedirect = usePromoBonusRedirect();

  const buttonRedirect = useCallback(() => {
    if (isPromoBonusSystemEnabled && bonus?.promotionId) {
      promoBonusRedirect(bonus.promotionId);
    } else {
      history.push(getBonusDetailRoute(bonus?.id));
    }
  }, [isPromoBonusSystemEnabled, bonus, history, promoBonusRedirect]);

  return (
    <Button
      size="low"
      variant="primary"
      loading={isLoading}
      onClick={buttonRedirect}
      className={styles.button}
    >
      <Local namespace={NAMESPACES.BONUS}>To bonus</Local>
    </Button>
  );
};
